export const createOrder = {
	buyFeesDisabled: false,
	stockTradeDisabled: false,
	maintenanceModeEnabled: false,
	mutualFundsDisabled: false,
}
